import { render, staticRenderFns } from "./social-learning-write.vue?vue&type=template&id=681b44bc&scoped=true&"
import script from "./social-learning-write.vue?vue&type=script&lang=js&"
export * from "./social-learning-write.vue?vue&type=script&lang=js&"
import style0 from "./social-learning-write.vue?vue&type=style&index=0&id=681b44bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681b44bc",
  null
  
)

export default component.exports